import { useCallback } from 'react';
import { useSocketEvent } from '@connect-x-app/hybrid-data-access';
import { ChatChannelJoined, ChatChannelLeft, FlightRoomUserStatus } from '@connect-x-app/shared-domain-models';

import { useChannelStore, useSocketStore } from '../../stores';

export const useChatChannelSocketEvents = () => {
  const { socket } = useSocketStore();
  const { addUserToChannel, removeUserFromChannel } = useChannelStore();

  const handleChatChannelJoined = useCallback(
    ({ channelId, chatroomId, participant }: ChatChannelJoined) => {
      addUserToChannel(chatroomId, channelId, { ...participant, status: FlightRoomUserStatus.JOINED });
    },
    [addUserToChannel],
  );

  const handleChatChannelLeft = useCallback(
    ({ channelId, chatroomId, participant }: ChatChannelLeft) => {
      removeUserFromChannel(chatroomId, channelId, participant.externalId);
    },
    [removeUserFromChannel],
  );

  useSocketEvent(socket, 'chat.channel-joined', handleChatChannelJoined);
  useSocketEvent(socket, 'chat.channel-left', handleChatChannelLeft);
};
